import React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';
import { ErrorAlertSvg } from '@assets';
import './style.scss';
import { connect } from 'react-redux';
import { getAccountUsernameFromPath } from '@share/utils';

interface IProps extends RouteComponentProps {}

class CondoDetailsServerErrorComponent extends React.Component<IProps> {
  refreshPage = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    const accountName = getAccountUsernameFromPath(this.props.history);
    return (
      <div className="condo-details-server-error">
        <div className="condo-details-server-error__wrapper">
          <div className="condo-details-server-error__icon">
            <ErrorAlertSvg />
          </div>
          <div className="condo-details-server-error__header">
            <FormattedMessage id="problem.with.our.system" />
          </div>
          <div className="condo-details-server-error__description">
            <FormattedMessage id="we.are.working.on.the.problem.try" />{' '}
            <a onClick={this.refreshPage}>
              <FormattedMessage id="refresh" />
            </a>{' '}
            <FormattedMessage id="this.page" />
          </div>
          <div className="condo-details-server-error__footer">
            <Link to={`/${accountName}${Routes.CondoSearch}${location.search}`}>
              <BlueButton>
                <FormattedMessage id="back" />
              </BlueButton>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export const CondoDetailsServerError = connect()(withRouter(CondoDetailsServerErrorComponent));
